import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncUnassignedFilterNudge = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-unassigned-filter-nudg" */ './main'),
	),
	getPreloadProps: () => ({}),
});
